import React from 'react';
import { Container, LeftContainer, RightContainer, TextTitle, TextContent } from './Styles';

interface CardIconProps {
  title: string;
  text: string | React.ReactNode;
  icon: React.ReactNode;
  style?: React.CSSProperties;
}

const CardIcon: React.FC<CardIconProps> = (props) => {
  const { title, text, icon, style, ...otherProps } = props;
  return (
    <Container style={style} {...otherProps}>
      <LeftContainer>{icon}</LeftContainer>
      <RightContainer>
        <TextTitle>{title}</TextTitle>
        <TextContent>{text}</TextContent>
      </RightContainer>
    </Container>
  );
};

export default CardIcon;
